import { useEffect } from 'react';
import { Progress } from '@backstage/core-components';
import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { useNavigate } from 'react-router-dom';
import { markSsoLoginPending, setToken } from '../../lib/sso';

/**
 * Ruta /callback (por si ya hay sesión Backstage):
 * guarda JWT SSO y manda al inicio. El SignInPage hace el exchange.
 */
function SsoCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const error = params.get('error');

    if (error) {
      navigate(`/?error=${encodeURIComponent(error)}`, { replace: true });
      return;
    }

    if (token) {
      setToken(token);
      markSsoLoginPending();
    }

    navigate('/', { replace: true });
  }, [navigate]);

  return <Progress />;
}

export const ssoCallbackPage = PageBlueprint.make({
  name: 'sso-callback',
  params: {
    path: '/callback',
    noHeader: true,
    loader: async () => <SsoCallback />,
  },
});
